import React from 'react';
import CURRENCY from 'utils/currency';
import { PAYMENTS } from 'state/payment/type';

interface IProps {
  row: PAYMENTS.TipByPaymentTypeAggregateItem;
}

const TipsAccordion = ({ row }: IProps): JSX.Element => {
  return (
    <div className="w-full text-sm font-normal leading-5 text-gray-blue-70">
      {row.tip_breakup.map((value, index) => (
        <div
          key={`${value.payment_type}-${index}`}
          // Mirror the parent Table's column template (auto 1.51fr 1fr 1fr 1fr)
          // so each breakup value aligns under its data column. The leading
          // 42px cell offsets the expand/chevron column.
          className="grid grid-cols-[42px_1.51fr_1fr_1fr_1fr] items-center"
        >
          <span aria-hidden="true" />
          <span className="px-3 py-1">
            {value.payment_type === 'ATM' ? 'CATM' : value.payment_type}
          </span>
          <span className="px-3 py-1">
            {CURRENCY.convertToMainUnit(value.tip_amount) || '$0.00'}
          </span>
          <span className="px-3 py-1">{value.number_of_tips}</span>
          <span className="px-3 py-1">
            {CURRENCY.convertToMainUnit(value.average_tip_amount) || '$0.00'}
          </span>
        </div>
      ))}
    </div>
  );
};

export default TipsAccordion;
